$(() => {
  $('.faq-question').on('click', function () {
    id = $(this).data('value');
    switch ($(this).attr('aria-expanded')) {
      case 'true':
        $('#plus-button-' + id).hide();
        $('#minus-button-' + id).show();
        break;
      case 'false':
        $('#minus-button-' + id).hide();
        $('#plus-button-' + id).show();
        break;
      }
  });
});
